import OnestockRiskAssessmentContainer from "./OnestockRiskAssessmentContainer";
import OnestockRiskAssessmentStore from "./OnestockRiskAssessmentStore";

export default OnestockRiskAssessmentStore(OnestockRiskAssessmentContainer);